require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-c-1-t-ygr-tk-2-j-dx-gag-6-pi-iqp-fn.json") })
        }
      }, "path---news-c-1-t-ygr-tk-2-j-dx-gag-6-pi-iqp-fn");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-c-1-t-ygr-tk-2-j-dx-gag-6-pi-iqp-fn!./.cache/json/news-c-1-t-ygr-tk-2-j-dx-gag-6-pi-iqp-fn.json
// module id = ./node_modules/gatsby-module-loader/index.js?name=path---news-c-1-t-ygr-tk-2-j-dx-gag-6-pi-iqp-fn!./.cache/json/news-c-1-t-ygr-tk-2-j-dx-gag-6-pi-iqp-fn.json
// module chunks = 231608221292675